import {
  useClientDefaultData,
  useInvoiceDefaultTemplate,
  useProjectDefaultBillingData
} from '~/modules/billing-invoicing/common/hooks';

const EMPTY_PROJECT_SETTINGS = {};

const getProjectBillingOverrides = projectRecord => {
  if (!projectRecord) return EMPTY_PROJECT_SETTINGS;

  const { invoiceCurrency, ...rest } = projectRecord;

  if (projectRecord.billLineItemsBy) {
    return {
      ...rest,
      ...(invoiceCurrency && { invoiceCurrency })
    };
  }

  return {
    poNumber: projectRecord.poNumber ?? null,
    ...(invoiceCurrency && { invoiceCurrency })
  };
};

export const useBillingDefaults = ({
  availableToBillProject,
  client,
  projectUri,
  isPsaPrpFixBillingDefaultsEnabled
}) => {
  const { invoiceDefaultTemplate } = useInvoiceDefaultTemplate();
  const { clientDefaultData } = useClientDefaultData({ client });

  const resolvedProject = isPsaPrpFixBillingDefaultsEnabled
    ? availableToBillProject || (projectUri ? { id: projectUri } : undefined)
    : availableToBillProject;

  const projectsBillingSettingsById = useProjectDefaultBillingData({
    projectIds: resolvedProject?.id ? [resolvedProject.id] : []
  });

  const projectRecord = resolvedProject?.id
    ? projectsBillingSettingsById[resolvedProject.id]
    : undefined;

  const projectSettings = isPsaPrpFixBillingDefaultsEnabled
    ? getProjectBillingOverrides(projectRecord)
    : projectRecord || EMPTY_PROJECT_SETTINGS;

  return {
    billingDefaults: {
      ...(clientDefaultData || {}),
      ...(clientDefaultData?.billingSettings || {}),
      ...projectSettings
    },
    invoiceDefaultTemplate,
    clientDefaultData
  };
};
